/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WeaknessDefinitionEntity } from './WeaknessDefinitionEntity';
import {
    WeaknessDefinitionEntityFromJSON,
    WeaknessDefinitionEntityFromJSONTyped,
    WeaknessDefinitionEntityToJSON,
    WeaknessDefinitionEntityToJSONTyped,
} from './WeaknessDefinitionEntity';
import type { BaselineAssessmentRun } from './BaselineAssessmentRun';
import {
    BaselineAssessmentRunFromJSON,
    BaselineAssessmentRunFromJSONTyped,
    BaselineAssessmentRunToJSON,
    BaselineAssessmentRunToJSONTyped,
} from './BaselineAssessmentRun';
import type { AssetResolutionStatus } from './AssetResolutionStatus';
import {
    AssetResolutionStatusFromJSON,
    AssetResolutionStatusFromJSONTyped,
    AssetResolutionStatusToJSON,
    AssetResolutionStatusToJSONTyped,
} from './AssetResolutionStatus';
import type { WeaknessOwnership } from './WeaknessOwnership';
import {
    WeaknessOwnershipFromJSON,
    WeaknessOwnershipFromJSONTyped,
    WeaknessOwnershipToJSON,
    WeaknessOwnershipToJSONTyped,
} from './WeaknessOwnership';
import type { BaselineEntity } from './BaselineEntity';
import {
    BaselineEntityFromJSON,
    BaselineEntityFromJSONTyped,
    BaselineEntityToJSON,
    BaselineEntityToJSONTyped,
} from './BaselineEntity';
import type { SystemBoundaryEntity } from './SystemBoundaryEntity';
import {
    SystemBoundaryEntityFromJSON,
    SystemBoundaryEntityFromJSONTyped,
    SystemBoundaryEntityToJSON,
    SystemBoundaryEntityToJSONTyped,
} from './SystemBoundaryEntity';
import type { WeaknessDefinitionTenantEntity } from './WeaknessDefinitionTenantEntity';
import {
    WeaknessDefinitionTenantEntityFromJSON,
    WeaknessDefinitionTenantEntityFromJSONTyped,
    WeaknessDefinitionTenantEntityToJSON,
    WeaknessDefinitionTenantEntityToJSONTyped,
} from './WeaknessDefinitionTenantEntity';

/**
 * Weakness data
 * @export
 * @interface WeaknessInstanceEntity
 */
export interface WeaknessInstanceEntity {
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessInstanceEntity
     */
    discoveredAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessInstanceEntity
     */
    lastSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessInstanceEntity
     */
    decommissionedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    status?: WeaknessInstanceEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof WeaknessInstanceEntity
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof WeaknessInstanceEntity
     */
    extendedAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof WeaknessInstanceEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessInstanceEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    goldenRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    assetGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    assetClass?: string;
    /**
     * 
     * @type {WeaknessDefinitionEntity}
     * @memberof WeaknessInstanceEntity
     */
    weaknessDefinition?: WeaknessDefinitionEntity;
    /**
     * 
     * @type {WeaknessDefinitionTenantEntity}
     * @memberof WeaknessInstanceEntity
     */
    weaknessDefinitionTenant?: WeaknessDefinitionTenantEntity;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    weaknessType?: WeaknessInstanceEntityWeaknessTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    framework?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeaknessInstanceEntity
     */
    assetIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeaknessInstanceEntity
     */
    containerIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    resolutionStatus?: WeaknessInstanceEntityResolutionStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessInstanceEntity
     */
    resolvedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    resolutionMethod?: WeaknessInstanceEntityResolutionMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    resolutionNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    findingState?: WeaknessInstanceEntityFindingStateEnum;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    stateSource?: WeaknessInstanceEntityStateSourceEnum;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessInstanceEntity
     */
    stateChangedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    stateChangedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    exceptionId?: string;
    /**
     * 
     * @type {{ [key: string]: AssetResolutionStatus; }}
     * @memberof WeaknessInstanceEntity
     */
    assetResolutionStatus?: { [key: string]: AssetResolutionStatus; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof WeaknessInstanceEntity
     */
    findingDetails?: { [key: string]: any; };
    /**
     * 
     * @type {BaselineEntity}
     * @memberof WeaknessInstanceEntity
     */
    baseline?: BaselineEntity;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    configItemId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof WeaknessInstanceEntity
     */
    expectedValue?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof WeaknessInstanceEntity
     */
    currentValue?: { [key: string]: any; };
    /**
     * 
     * @type {BaselineAssessmentRun}
     * @memberof WeaknessInstanceEntity
     */
    assessmentRun?: BaselineAssessmentRun;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof WeaknessInstanceEntity
     */
    driftHistory?: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    assignedTo?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    assignedToEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    assignedToType?: WeaknessInstanceEntityAssignedToTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    assignedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessInstanceEntity
     */
    assignedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    assignmentReason?: string;
    /**
     * 
     * @type {WeaknessOwnership}
     * @memberof WeaknessInstanceEntity
     */
    ownership?: WeaknessOwnership;
    /**
     * 
     * @type {number}
     * @memberof WeaknessInstanceEntity
     */
    priorityScore?: number;
    /**
     * 
     * @type {string}
     * @memberof WeaknessInstanceEntity
     */
    priorityLevel?: WeaknessInstanceEntityPriorityLevelEnum;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessInstanceEntity
     */
    priorityCalculatedAt?: Date;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof WeaknessInstanceEntity
     */
    prioritizationFactors?: { [key: string]: any; };
    /**
     * 
     * @type {Set<SystemBoundaryEntity>}
     * @memberof WeaknessInstanceEntity
     */
    affectedBoundaries?: Set<SystemBoundaryEntity>;
    /**
     * 
     * @type {boolean}
     * @memberof WeaknessInstanceEntity
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WeaknessInstanceEntity
     */
    decommissioned?: boolean;
}


/**
 * @export
 */
export const WeaknessInstanceEntityStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Decommissioned: 'DECOMMISSIONED',
    Deleted: 'DELETED'
} as const;
export type WeaknessInstanceEntityStatusEnum = typeof WeaknessInstanceEntityStatusEnum[keyof typeof WeaknessInstanceEntityStatusEnum];

/**
 * @export
 */
export const WeaknessInstanceEntityWeaknessTypeEnum = {
    Vulnerability: 'VULNERABILITY',
    ConfigurationFinding: 'CONFIGURATION_FINDING',
    ComplianceGap: 'COMPLIANCE_GAP',
    PolicyGap: 'POLICY_GAP',
    InsuranceGap: 'INSURANCE_GAP',
    ProcedureGap: 'PROCEDURE_GAP',
    RedTeamFinding: 'RED_TEAM_FINDING',
    SecurityAssessment: 'SECURITY_ASSESSMENT',
    PenetrationTest: 'PENETRATION_TEST',
    NetworkMisconfiguration: 'NETWORK_MISCONFIGURATION',
    AccessControlIssue: 'ACCESS_CONTROL_ISSUE',
    IdentityMisconfiguration: 'IDENTITY_MISCONFIGURATION',
    ApplicationSecurity: 'APPLICATION_SECURITY',
    ApiSecurity: 'API_SECURITY',
    CspmFinding: 'CSPM_FINDING',
    CloudMisconfiguration: 'CLOUD_MISCONFIGURATION',
    Custom: 'CUSTOM',
    Other: 'OTHER'
} as const;
export type WeaknessInstanceEntityWeaknessTypeEnum = typeof WeaknessInstanceEntityWeaknessTypeEnum[keyof typeof WeaknessInstanceEntityWeaknessTypeEnum];

/**
 * @export
 */
export const WeaknessInstanceEntityResolutionStatusEnum = {
    Unresolved: 'UNRESOLVED',
    PartiallyResolved: 'PARTIALLY_RESOLVED',
    Resolved: 'RESOLVED'
} as const;
export type WeaknessInstanceEntityResolutionStatusEnum = typeof WeaknessInstanceEntityResolutionStatusEnum[keyof typeof WeaknessInstanceEntityResolutionStatusEnum];

/**
 * @export
 */
export const WeaknessInstanceEntityResolutionMethodEnum = {
    Patched: 'PATCHED',
    ConfigurationFixed: 'CONFIGURATION_FIXED',
    WorkaroundApplied: 'WORKAROUND_APPLIED',
    AssetDecommissioned: 'ASSET_DECOMMISSIONED',
    FalsePositive: 'FALSE_POSITIVE',
    PolicyImplemented: 'POLICY_IMPLEMENTED',
    InsuranceObtained: 'INSURANCE_OBTAINED',
    RiskAccepted: 'RISK_ACCEPTED',
    Other: 'OTHER'
} as const;
export type WeaknessInstanceEntityResolutionMethodEnum = typeof WeaknessInstanceEntityResolutionMethodEnum[keyof typeof WeaknessInstanceEntityResolutionMethodEnum];

/**
 * @export
 */
export const WeaknessInstanceEntityFindingStateEnum = {
    Open: 'OPEN',
    Remediated: 'REMEDIATED',
    FalsePositive: 'FALSE_POSITIVE',
    RiskAccepted: 'RISK_ACCEPTED',
    Exception: 'EXCEPTION',
    Suppressed: 'SUPPRESSED',
    RemediationPending: 'REMEDIATION_PENDING'
} as const;
export type WeaknessInstanceEntityFindingStateEnum = typeof WeaknessInstanceEntityFindingStateEnum[keyof typeof WeaknessInstanceEntityFindingStateEnum];

/**
 * @export
 */
export const WeaknessInstanceEntityStateSourceEnum = {
    Scanner: 'SCANNER',
    Analyst: 'ANALYST',
    Policy: 'POLICY',
    System: 'SYSTEM'
} as const;
export type WeaknessInstanceEntityStateSourceEnum = typeof WeaknessInstanceEntityStateSourceEnum[keyof typeof WeaknessInstanceEntityStateSourceEnum];

/**
 * @export
 */
export const WeaknessInstanceEntityAssignedToTypeEnum = {
    Individual: 'INDIVIDUAL',
    Team: 'TEAM',
    Group: 'GROUP'
} as const;
export type WeaknessInstanceEntityAssignedToTypeEnum = typeof WeaknessInstanceEntityAssignedToTypeEnum[keyof typeof WeaknessInstanceEntityAssignedToTypeEnum];

/**
 * @export
 */
export const WeaknessInstanceEntityPriorityLevelEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Unknown: 'UNKNOWN'
} as const;
export type WeaknessInstanceEntityPriorityLevelEnum = typeof WeaknessInstanceEntityPriorityLevelEnum[keyof typeof WeaknessInstanceEntityPriorityLevelEnum];


/**
 * Check if a given object implements the WeaknessInstanceEntity interface.
 */
export function instanceOfWeaknessInstanceEntity(value: object): value is WeaknessInstanceEntity {
    return true;
}

export function WeaknessInstanceEntityFromJSON(json: any): WeaknessInstanceEntity {
    return WeaknessInstanceEntityFromJSONTyped(json, false);
}

export function WeaknessInstanceEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeaknessInstanceEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : (new Date(json['discoveredAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
        'extendedAttributes': json['extendedAttributes'] == null ? undefined : json['extendedAttributes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'goldenRecordId': json['goldenRecordId'] == null ? undefined : json['goldenRecordId'],
        'assetGoldenId': json['assetGoldenId'] == null ? undefined : json['assetGoldenId'],
        'assetClass': json['assetClass'] == null ? undefined : json['assetClass'],
        'weaknessDefinition': json['weaknessDefinition'] == null ? undefined : WeaknessDefinitionEntityFromJSON(json['weaknessDefinition']),
        'weaknessDefinitionTenant': json['weaknessDefinitionTenant'] == null ? undefined : WeaknessDefinitionTenantEntityFromJSON(json['weaknessDefinitionTenant']),
        'weaknessType': json['weaknessType'] == null ? undefined : json['weaknessType'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'framework': json['framework'] == null ? undefined : json['framework'],
        'assetIds': json['assetIds'] == null ? undefined : json['assetIds'],
        'containerIds': json['containerIds'] == null ? undefined : json['containerIds'],
        'resolutionStatus': json['resolutionStatus'] == null ? undefined : json['resolutionStatus'],
        'resolvedAt': json['resolvedAt'] == null ? undefined : (new Date(json['resolvedAt'])),
        'resolvedBy': json['resolvedBy'] == null ? undefined : json['resolvedBy'],
        'resolutionMethod': json['resolutionMethod'] == null ? undefined : json['resolutionMethod'],
        'resolutionNotes': json['resolutionNotes'] == null ? undefined : json['resolutionNotes'],
        'findingState': json['findingState'] == null ? undefined : json['findingState'],
        'stateSource': json['stateSource'] == null ? undefined : json['stateSource'],
        'stateChangedAt': json['stateChangedAt'] == null ? undefined : (new Date(json['stateChangedAt'])),
        'stateChangedBy': json['stateChangedBy'] == null ? undefined : json['stateChangedBy'],
        'exceptionId': json['exceptionId'] == null ? undefined : json['exceptionId'],
        'assetResolutionStatus': json['assetResolutionStatus'] == null ? undefined : (mapValues(json['assetResolutionStatus'], AssetResolutionStatusFromJSON)),
        'findingDetails': json['findingDetails'] == null ? undefined : json['findingDetails'],
        'baseline': json['baseline'] == null ? undefined : BaselineEntityFromJSON(json['baseline']),
        'configItemId': json['configItemId'] == null ? undefined : json['configItemId'],
        'expectedValue': json['expectedValue'] == null ? undefined : json['expectedValue'],
        'currentValue': json['currentValue'] == null ? undefined : json['currentValue'],
        'assessmentRun': json['assessmentRun'] == null ? undefined : BaselineAssessmentRunFromJSON(json['assessmentRun']),
        'driftHistory': json['driftHistory'] == null ? undefined : json['driftHistory'],
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'assignedToEmail': json['assignedToEmail'] == null ? undefined : json['assignedToEmail'],
        'assignedToType': json['assignedToType'] == null ? undefined : json['assignedToType'],
        'assignedBy': json['assignedBy'] == null ? undefined : json['assignedBy'],
        'assignedAt': json['assignedAt'] == null ? undefined : (new Date(json['assignedAt'])),
        'assignmentReason': json['assignmentReason'] == null ? undefined : json['assignmentReason'],
        'ownership': json['ownership'] == null ? undefined : WeaknessOwnershipFromJSON(json['ownership']),
        'priorityScore': json['priorityScore'] == null ? undefined : json['priorityScore'],
        'priorityLevel': json['priorityLevel'] == null ? undefined : json['priorityLevel'],
        'priorityCalculatedAt': json['priorityCalculatedAt'] == null ? undefined : (new Date(json['priorityCalculatedAt'])),
        'prioritizationFactors': json['prioritizationFactors'] == null ? undefined : json['prioritizationFactors'],
        'affectedBoundaries': json['affectedBoundaries'] == null ? undefined : (new Set((json['affectedBoundaries'] as Array<any>).map(SystemBoundaryEntityFromJSON))),
        'active': json['active'] == null ? undefined : json['active'],
        'decommissioned': json['decommissioned'] == null ? undefined : json['decommissioned'],
    };
}

export function WeaknessInstanceEntityToJSON(json: any): WeaknessInstanceEntity {
    return WeaknessInstanceEntityToJSONTyped(json, false);
}

export function WeaknessInstanceEntityToJSONTyped(value?: WeaknessInstanceEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'discoveredAt': value['discoveredAt'] == null ? undefined : ((value['discoveredAt']).toISOString()),
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
        'decommissionedAt': value['decommissionedAt'] == null ? undefined : ((value['decommissionedAt']).toISOString()),
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'version': value['version'],
        'extendedAttributes': value['extendedAttributes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'goldenRecordId': value['goldenRecordId'],
        'assetGoldenId': value['assetGoldenId'],
        'assetClass': value['assetClass'],
        'weaknessDefinition': WeaknessDefinitionEntityToJSON(value['weaknessDefinition']),
        'weaknessDefinitionTenant': WeaknessDefinitionTenantEntityToJSON(value['weaknessDefinitionTenant']),
        'weaknessType': value['weaknessType'],
        'identifier': value['identifier'],
        'framework': value['framework'],
        'assetIds': value['assetIds'],
        'containerIds': value['containerIds'],
        'resolutionStatus': value['resolutionStatus'],
        'resolvedAt': value['resolvedAt'] == null ? undefined : ((value['resolvedAt']).toISOString()),
        'resolvedBy': value['resolvedBy'],
        'resolutionMethod': value['resolutionMethod'],
        'resolutionNotes': value['resolutionNotes'],
        'findingState': value['findingState'],
        'stateSource': value['stateSource'],
        'stateChangedAt': value['stateChangedAt'] == null ? undefined : ((value['stateChangedAt']).toISOString()),
        'stateChangedBy': value['stateChangedBy'],
        'exceptionId': value['exceptionId'],
        'assetResolutionStatus': value['assetResolutionStatus'] == null ? undefined : (mapValues(value['assetResolutionStatus'], AssetResolutionStatusToJSON)),
        'findingDetails': value['findingDetails'],
        'baseline': BaselineEntityToJSON(value['baseline']),
        'configItemId': value['configItemId'],
        'expectedValue': value['expectedValue'],
        'currentValue': value['currentValue'],
        'assessmentRun': BaselineAssessmentRunToJSON(value['assessmentRun']),
        'driftHistory': value['driftHistory'],
        'assignedTo': value['assignedTo'],
        'assignedToEmail': value['assignedToEmail'],
        'assignedToType': value['assignedToType'],
        'assignedBy': value['assignedBy'],
        'assignedAt': value['assignedAt'] == null ? undefined : ((value['assignedAt']).toISOString()),
        'assignmentReason': value['assignmentReason'],
        'ownership': WeaknessOwnershipToJSON(value['ownership']),
        'priorityScore': value['priorityScore'],
        'priorityLevel': value['priorityLevel'],
        'priorityCalculatedAt': value['priorityCalculatedAt'] == null ? undefined : ((value['priorityCalculatedAt']).toISOString()),
        'prioritizationFactors': value['prioritizationFactors'],
        'affectedBoundaries': value['affectedBoundaries'] == null ? undefined : (Array.from(value['affectedBoundaries'] as Set<any>).map(SystemBoundaryEntityToJSON)),
        'active': value['active'],
        'decommissioned': value['decommissioned'],
    };
}

